module.exports = __webpack_public_path__ + "static/media/energon-logo.275e8659.png";